__turbopack_context__.v({
  "callout": "CardSection-module__UJrulq__callout",
  "calloutInner": "CardSection-module__UJrulq__calloutInner",
  "carouselBadgeRoomSm": "CardSection-module__UJrulq__carouselBadgeRoomSm",
  "carouselContentSm": "CardSection-module__UJrulq__carouselContentSm",
  "carouselFullSm": "CardSection-module__UJrulq__carouselFullSm",
  "carouselItemSm": "CardSection-module__UJrulq__carouselItemSm",
  "carouselPadSm": "CardSection-module__UJrulq__carouselPadSm",
  "carouselWrap": "CardSection-module__UJrulq__carouselWrap",
  "centerColumn": "CardSection-module__UJrulq__centerColumn",
  "container": "CardSection-module__UJrulq__container",
  "divider": "CardSection-module__UJrulq__divider",
  "dividerGapLg": "CardSection-module__UJrulq__dividerGapLg",
  "dividerGapMd": "CardSection-module__UJrulq__dividerGapMd",
  "dividerGapNone": "CardSection-module__UJrulq__dividerGapNone",
  "dividerGapSm": "CardSection-module__UJrulq__dividerGapSm",
  "dividerGapXl": "CardSection-module__UJrulq__dividerGapXl",
  "gapLg": "CardSection-module__UJrulq__gapLg",
  "gapMd": "CardSection-module__UJrulq__gapMd",
  "gapSm": "CardSection-module__UJrulq__gapSm",
  "heroButtons": "CardSection-module__UJrulq__heroButtons",
  "heroCard": "CardSection-module__UJrulq__heroCard",
  "heroCardSpacing": "CardSection-module__UJrulq__heroCardSpacing",
  "heroHeader": "CardSection-module__UJrulq__heroHeader",
  "heroInner": "CardSection-module__UJrulq__heroInner",
  "heroSection": "CardSection-module__UJrulq__heroSection",
  "hideSm": "CardSection-module__UJrulq__hideSm",
  "noShadow": "CardSection-module__UJrulq__noShadow",
  "oneUpImage": "CardSection-module__UJrulq__oneUpImage",
  "oneUpWrap": "CardSection-module__UJrulq__oneUpWrap",
  "onlySm": "CardSection-module__UJrulq__onlySm",
  "priceHeader": "CardSection-module__UJrulq__priceHeader",
  "showcaseLeftGrid": "CardSection-module__UJrulq__showcaseLeftGrid",
  "showcaseList": "CardSection-module__UJrulq__showcaseList",
  "showcaseMedia": "CardSection-module__UJrulq__showcaseMedia",
  "showcaseRightGrid": "CardSection-module__UJrulq__showcaseRightGrid",
  "stickyText": "CardSection-module__UJrulq__stickyText",
  "tabsRow": "CardSection-module__UJrulq__tabsRow",
  "testimonialCarouselContent": "CardSection-module__UJrulq__testimonialCarouselContent",
  "testimonialCarouselItem": "CardSection-module__UJrulq__testimonialCarouselItem",
  "testimonialCarouselNext": "CardSection-module__UJrulq__testimonialCarouselNext",
  "testimonialCarouselPrev": "CardSection-module__UJrulq__testimonialCarouselPrev",
  "testimonialCarouselWrap": "CardSection-module__UJrulq__testimonialCarouselWrap",
  "testimonialHeader": "CardSection-module__UJrulq__testimonialHeader",
  "twoUp4060Grid": "CardSection-module__UJrulq__twoUp4060Grid",
  "twoUp4060Image": "CardSection-module__UJrulq__twoUp4060Image",
  "twoUp4060Text": "CardSection-module__UJrulq__twoUp4060Text",
  "twoUp5050Grid": "CardSection-module__UJrulq__twoUp5050Grid",
  "twoUp5050Image": "CardSection-module__UJrulq__twoUp5050Image",
  "twoUp5050Text": "CardSection-module__UJrulq__twoUp5050Text",
  "twoUp6040Grid": "CardSection-module__UJrulq__twoUp6040Grid",
  "twoUp6040Image": "CardSection-module__UJrulq__twoUp6040Image",
  "twoUp6040Text": "CardSection-module__UJrulq__twoUp6040Text",
});
